module.exports = __webpack_public_path__ + "img/level_two.44339f15.png";